module.exports = __webpack_public_path__ + "static/musashi-fb7893a0de96d2787b10fd8c90fcfa59.jpg";